<template>
  <div>
    {{ $t('developers.pleaseVisitOur') }} <a href="https://primesurveys.com/docs/web">{{ $t('developers.sdkDocumentation') }}</a>.
  </div>
</template>

<script>
export default {
  created() {
    this.hideLoading()
  },
}
</script>

<style>

</style>
